import { useState } from 'react';

export function useForceRefresh() {
  const [, setValue] = useState(0);
  return () => setValue((value) => value + 1);
}
